import { useState } from "react";
import { FileDown, Lock, Unlock, Mail, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { TextField, AreaField, Card } from "../Field";
import { generatePdf } from "../../lib/pdf";
import { formatDatum } from "../../lib/storage";

export default function PregledTab({ record, update, settings }) {
  const p = record.pregled;
  const set = (k) => (v) => update({ pregled: { ...p, [k]: v } });
  const [busy, setBusy] = useState(false);

  const downloadPdf = async () => {
    setBusy(true);
    try {
      await generatePdf(record, settings);
      toast.success("PDF izvještaj je preuzet");
    } catch (e) {
      toast.error("Greška pri izradi PDF-a");
      console.error(e);
    }
    setBusy(false);
  };

  const mailto = () => {
    const subject = encodeURIComponent(`Dnevna evidencija dežuranja - ${formatDatum(record.datum)}`);
    const body = encodeURIComponent(
      `Poštovani,\n\nu privitku dostavljam dnevnu evidenciju dežuranja za ${formatDatum(record.datum)} (${record.tip === "nastavni" ? "nastavni dan" : "nenastavni dan"}).\n\nNapomena: PDF izvještaj potrebno je ručno priložiti poruci.\n\nS poštovanjem`
    );
    window.location.href = `mailto:${settings.emailRavnatelja || ""}?subject=${subject}&body=${body}`;
  };

  return (
    <div className="grid gap-5">
      <Card title="Pregled i zaključavanje" subtitle="Završni podaci o evidenciji">
        <TextField label="Evidenciju zaključao/la" value={p.zakljucao} onChange={set("zakljucao")} testId="form-zakljucao-input" placeholder="Ime i prezime" />
        <TextField label="Ravnatelj pregledao dana" value={p.ravnateljPregledao} onChange={set("ravnateljPregledao")} testId="form-ravnatelj-pregledao-input" placeholder="npr. 15.06.2026." />
        <AreaField label="Zapažanja ravnatelja" value={p.zapazanjaRavnatelja} onChange={set("zapazanjaRavnatelja")} testId="form-zapazanja-ravnatelja-input" rows={4} />
      </Card>

      <Card title="Status evidencije" subtitle={p.zakljucano ? "Evidencija je zaključana i zaštićena od izmjena" : "Evidencija je otvorena za unos"} badge={p.zakljucano ? "Zaključano" : "Otvoreno"}>
        <button
          data-testid="zakljuci-dnevnik-btn"
          onClick={() => {
            set("zakljucano")(!p.zakljucano);
            toast.success(p.zakljucano ? "Evidencija je otključana" : "Evidencija je zaključana");
          }}
          className={`inline-flex items-center gap-2 rounded-xl px-4 py-2.5 text-sm font-semibold shadow-sm transition-colors active:scale-[0.98] ${
            p.zakljucano
              ? "border border-slate-300 bg-white text-slate-700 hover:bg-slate-50"
              : "bg-slate-900 text-white hover:bg-slate-800"
          }`}
        >
          {p.zakljucano ? <Unlock className="h-4 w-4" /> : <Lock className="h-4 w-4" />}
          {p.zakljucano ? "Otključaj evidenciju" : "Zaključaj evidenciju"}
        </button>
      </Card>

      <Card title="Izvještaj za ravnatelja" subtitle="Preuzmite PDF i pošaljite ga ravnatelju e-poštom">
        <div className="flex flex-wrap gap-3">
          <button
            data-testid="generiraj-pdf-btn"
            onClick={downloadPdf}
            disabled={busy}
            className="inline-flex items-center gap-2 rounded-xl bg-sky-600 px-5 py-3 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-sky-700 active:scale-[0.98] disabled:opacity-60"
          >
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <FileDown className="h-4 w-4" />}
            Preuzmi PDF izvještaj
          </button>
          <button
            data-testid="posalji-ravnatelju-btn"
            onClick={mailto}
            className="inline-flex items-center gap-2 rounded-xl border border-sky-200 bg-sky-50 px-5 py-3 text-sm font-semibold text-sky-700 transition-colors hover:bg-sky-100 active:scale-[0.98]"
          >
            <Mail className="h-4 w-4" /> Pošalji ravnatelju
          </button>
        </div>
        <p className="text-xs text-slate-400">Gumb "Pošalji ravnatelju" otvara vaš program za e-poštu s pripremljenom porukom. Preuzeti PDF priložite ručno.</p>
      </Card>
    </div>
  );
}
